import React, { Component } from "react"
import PropTypes from 'prop-types';
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import { logoutUser } from "../../store/actions"

class Logout extends Component {
  /**
   * Redirect to login
   */
  componentDidMount = () => {

    let tempLang = localStorage.getItem("I18N_LANGUAGE");
    let tempLang2 = localStorage.getItem("i18nextLng");
    localStorage.clear();

    localStorage.setItem("I18N_LANGUAGE", tempLang);
    localStorage.setItem("i18nextLng", tempLang2);
    
    this.props.logoutUser(this.props.history)
  }

  render() {
    return <React.Fragment></React.Fragment>
  }
}

Logout.propTypes = {
  history: PropTypes.any,
  logoutUser: PropTypes.func
}

export default withRouter(connect(null, { logoutUser })(Logout))
